import React from 'react';
import { FormControlLabel, Checkbox, Typography, Grid } from '@material-ui/core';

import { ClientContext } from '../../ClientContext';

export function ShowInitialPageCheckbox() {
    const clientContext = React.useContext(ClientContext);

    return (
        <Grid item xs={12}>
            <Typography variant="subtitle1">
                Exibir página inicial
            </Typography>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={clientContext.client.showDashInitialPage}
                        onChange={() => clientContext.setClient({ ...clientContext.client, showDashInitialPage: !clientContext.client.showDashInitialPage })}
                        name="Ativo"
                        color="primary" />
                }
                label="Ativo" />
        </Grid>
    );
}